// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetEventsRequestModel from '../../model/get-widget-events-request-model';
import GetWidgetEventsRequestDTO from '../dto/get-widget-events-request-dto';
import dtoSchema from '../schemas/get-widget-events-request-schema';
import ApiPagingRequestModel from '../../model/api-paging-request-model';

export default abstract class GetWidgetEventsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetEventsRequestDTO>) {
    super();
    if (data) {
      this.searchCriteria = data.searchCriteria ?? undefined;
      this.paging = data.paging ? ApiPagingRequestModel.toModel(data.paging) : undefined;
      this.toccoFilter = data.toccoFilter;
      this.searchTag = data.searchTag ?? undefined;
    }
  }
  /**
  */
  searchCriteria?: string;
  /**
  */
  paging?: ApiPagingRequestModel;
  /**
  * @minimum 1
  */
  toccoFilter?: string;
  /**
  */
  searchTag?: string;

  static toModel(dto: DeepPartial<GetWidgetEventsRequestDTO>): GetWidgetEventsRequestModel;
  static toModel(dto: DeepPartial<GetWidgetEventsRequestDTO> | undefined | null): GetWidgetEventsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetEventsRequestDTO> | undefined | null): GetWidgetEventsRequestModel | undefined {
    return dto ? new GetWidgetEventsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetEventsRequestModel> | GetWidgetEventsRequestModel): GetWidgetEventsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      searchCriteria: unwrapped.searchCriteria,
      paging: unwrapped.paging,
      toccoFilter: unwrapped.toccoFilter,
      searchTag: unwrapped.searchTag,
    } as GetWidgetEventsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetEventsRequestModel, can not map to GetWidgetEventsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
